import { FileListFileProps } from '@/lib'
import { filesize } from 'filesize'

export const formatFilesToFileListFiles = (files: File[]): FileListFileProps[] => {
  return files.map((file, i) => ({
    file,
    id: i,
    name: file.name,
    readableSize: filesize(file.size),
    preview: URL.createObjectURL(file),
    progress: 0,
    uploaded: true,
    error: false,
    url: undefined,
  }))
}
